// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1ESWn","imageUploader":"EGiftCard_imageUploader__3sgyy"};